<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24"
        ><Breadcrumbs :arr="['碳汇管理平台', '人员信息']"
      /></el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input
              size="small"
              v-model="search.name"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="上课方式">
            <el-select
              v-model="search.attendClassWay"
              clearable
              placeholder="请选择"
              size="small"
            >
              <el-option label="线上" :value="0"> </el-option>
              <el-option label="线下" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item id="time" label="日期">
            <el-date-picker
            v-model="search.startDate"
            type="datetime"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear"
            style="width: 200px"
            placeholder="开始日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker
            v-model="search.endDate"
            type="datetime"
            size="small"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear1"
            value-format="yyyy-MM-dd"
            style="width: 200px"
            placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round
              >查询</el-button
            >
            <el-button
              size="small"
              style="margin: 0 0 0 50px"
              @click="reset"
              round
              type="info"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn"></div>
        <Tables
          class="table"
          :columns="columns"
          :loading="loading"
          :tableData="tableData"
        >
          <template #dinner="scope"><div>{{changeDinner(scope.row.dinner)}}</div></template>
          <template #transport="scope"><div>{{changeTransport(scope.row.transport)}}</div></template>
          <template #attendClassWay="scope"><div>{{changeAttendClassWay(scope.row.attendClassWay)}}</div></template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  getClassroomList,
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "policyInformation",
  data() {
    return {
      search: {
        name: "",
	      attendClassWay: "",
        startDate:"",
        endDate:"",
      },
      pickerOptionsYear: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.startDate);
          const end = Date.parse(this.search.endDate);
          if (this.search.endDate) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsYear1: {
          disabledDate: (time) => {
            const start = Date.parse(this.search.startDate);
            const end = Date.parse(this.search.endDate);
            if (this.search.startDate) {
              return (
                time.getTime() < start - 8.64e7
              );
            } else {
              // return time.getTime() > Date.now();
            }
          },
      },
      // 表格展示数据
      tableData: [],
      // 表格显示标题
      columns: [],
      loading: false,
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 用户信息
      userInfo: {},
    };
  },
  methods: {
    // 页面初始化
    init() {
      this.columns = columns;
      this.getList();
    },
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      getClassroomList(this.search, page).then((res) => {
        if (res.data.code == "200") {
          this.tableData = res.data.data.records;
          this.pageData.total = res.data.data.total;
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search =  {
        name: "",
	      attendClassWay: "",
        startDate:"",
        endDate:"",
      }
      this.getList();
    },
    // 切换条数
    sizeChange(val){
        this.pageData.size = val
        this.getList()
    },
    // 切换页数
    currentChange(val){
        this.pageData.page = val
        this.getList()
    },
    // 修改上课方式
    changeAttendClassWay(val){
      if(val==0) return '线上'
      else if(val == 1) return '线下'
      else return '' 
    },
    // 修改交通方式
    changeTransport(val){
      if(val==0) return '大巴'
      else if(val == 1) return '自驾'
      else if(val == 2) return '飞机'
      // else if(val == 1) return '自驾-小型汽油汽车'
      // else if(val == 2) return '自驾-电式混合汽车'
      // else if(val == 3) return '自驾-小型电动汽车'
      else return '' 
    },
    // 修改是否用餐
    changeDinner(val){
      if(val==0) return '否'
      else if(val == 1) return '是'
      else return '' 
    }
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    Paginations,
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.operation{
  color: #409EFF;
}
</style>